"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CashEuro;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CashEuro(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Cash"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Payment_methods",
    "data-name": "Payment methods"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "cash-euro"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M88.232,76.069a36.842,36.842,0,0,1-62.16-18.631H71.281a2.5,2.5,0,0,0,0-5H25.4a37.247,37.247,0,0,1,.178-6.809H78.17a2.5,2.5,0,0,0,0-5H26.523a36.852,36.852,0,0,1,61.709-16.7A2.5,2.5,0,0,0,91.768,20.4,41.837,41.837,0,0,0,21.379,40.629H10a2.5,2.5,0,0,0,0,5H20.548a42.31,42.31,0,0,0-.155,6.809H11.968a2.5,2.5,0,0,0,0,5h9.017A41.848,41.848,0,0,0,91.768,79.6a2.5,2.5,0,0,0-3.536-3.535Z"
  }))));
}